/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PenToolIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="pen-tool"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M3.672 20.328L15.692 18.914L16.399 11.843L12.157 7.601L5.086 8.308L3.672 20.328Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M19.581 12.197C18.8 12.978 17.534 12.978 16.753 12.197L11.803 7.247C11.022 6.466 11.022 5.2 11.803 4.419C12.584 3.637 13.851 3.637 14.632 4.419L19.581 9.368C20.363 10.149 20.363 11.416 19.581 12.197Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.672 20.328L9.328 14.672" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M11.803 15.025A2.5 2.5 225 0 1 8.975 12.197" data-tinysvg-shape="arc" data-tinysvg-arc="11.45 12.55 2.5 2.5 216.87 323.13 225 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
